import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type MoneyIconProps = CommonSvgProps

const MoneyIcon: React.FC<MoneyIconProps> = React.forwardRef<SVGSVGElement, MoneyIconProps>(
  (props, ref) => (
    <Svg viewBox="0 0 80 51" {...props} ref={ref} color="none">
      <rect x="2" y="2" width="70" height="40" rx="4" stroke="#51565C" strokeWidth="3" />
      <path
        d="M28.5 49L74 49C76.2091 49 78 47.2091 78 45L78 19"
        stroke="#51565C"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <circle cx="37" cy="22" r="9.5" fill="#7BB835" stroke="#51565C" strokeWidth="3" />
      <path d="M12 2L12 7C12 9.20914 10.2091 11 8 11L3 11" stroke="#51565C" strokeWidth="3" />
      <path d="M62 41L62 36C62 33.7909 63.7909 32 66 32L71 32" stroke="#51565C" strokeWidth="3" />
      <path d="M3 32H8C10.2091 32 12 33.7909 12 36L12 41" stroke="#51565C" strokeWidth="3" />
      <path d="M71 11L66 11C63.7909 11 62 9.20914 62 7L62 2" stroke="#51565C" strokeWidth="3" />
    </Svg>
  )
)

MoneyIcon.propTypes = commonPropTypes
MoneyIcon.defaultProps = commonDefaultProps

export default MoneyIcon
